import React, { Component } from "react";

import { Spin, Row } from "antd";

import K from "../../../services/constants";

export default class Slimpay extends Component {
  createMarkup(html) {
    return { __html: html };
  }

  componentDidMount() {
    this.socket = new WebSocket(K.SLIMPAY_WS_URL);

    this.socket.addEventListener("open", event => {
      console.log("opening the socket... id -> ", this.props.profileId);
      this.socket.send(JSON.stringify({ type: "salutation", message: { id: this.props.profileId } }));
    });

    this.socket.addEventListener("message", event => {
      console.log("message from server...", event);
      try {
        this.props.callback(JSON.parse(event.data));
      } catch (e) {
        this.props.callback({ error: "error parsing data!" });
      }
    });
  }

  componentWillUnmount() {
    this.socket && this.socket.close();
  }

  render() {
    const { html } = this.props;
    return (
      <Row className="slimpay">
        {!html && <Spin tip="Redirecting to Slimpay iframe..." />}
        {html && <div className="iframe" dangerouslySetInnerHTML={this.createMarkup(html)} />}
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/RegistrationSteps/Step_4/Slimpay.js